import React, { useMemo } from "react";
import { DEFAULT_TEXT, getUserConfigText } from "../../config";
import "./ChatHeader.module.css";
import { mapIconUrlToGCP } from "../../common/gcp";
import { useConfig } from "../Widget/ConfigContext";
import { calcContrastColor } from "../Widget/BubbleWidget";
/**
 * @typedef {import('../../types/config').ConfigObject} ConfigObject
 */

export default function ChatHeader({
  toggleChatOpen,
  resetConversation,
  adminConnected,
  downloadTranscript,
}) {
  const { config, colors } = useConfig();

  const handleResetClick = async () => {
    resetConversation().then(() => {});
  };
  const titleText = useMemo(
    () => getUserConfigText(config, "title", DEFAULT_TEXT.en.title),
    [document.cookie, config.overrideLanguage],
  );
  const subTitleText = useMemo(
    () => getUserConfigText(config, "subtitle", DEFAULT_TEXT.en.subtitle),
    [document.cookie, config.overrideLanguage],
  );
  const resetText = useMemo(
    () => getUserConfigText(config, "reset", DEFAULT_TEXT.en.reset),
    [document.cookie, config.overrideLanguage],
  );
  const closeText = useMemo(
    () => getUserConfigText(config, "close", DEFAULT_TEXT.en.close),
    [document.cookie, config.overrideLanguage],
  );
  const downloadText = useMemo(
    () =>
      getUserConfigText(
        config,
        "downloadTranscript",
        DEFAULT_TEXT.en.downloadTranscript,
      ),
    [document.cookie, config.overrideLanguage],
  );
  const headerDisclaimerText = useMemo(
    () =>
      getUserConfigText(
        config,
        "headerDisclaimer",
        DEFAULT_TEXT.en.headerDisclaimer,
      ),
    [document.cookie, config.overrideLanguage],
  );

  return (
    <>
      <div
        style={{
          backgroundColor: colors.main,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "65px",
          minHeight: "65px",
          maxHeight: "65px",
          borderRadius:
            config.widgetType === "inline" ? "0" : "0.75rem 0.75rem 0 0",
          margin: "0",
        }}
      >
        <div
          style={{
            backgroundColor: colors.main,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%",
            borderRadius:
              config.widgetType === "inline" ? "0" : "0.75rem 0.75rem 0 0",
            margin: "0",
            marginLeft: "10px",
          }}
        >
          {config?.profileImageUrl && (
            <img
              src={config.profileImageUrl}
              style={{
                objectFit: "cover",
                borderRadius: "50%",
                height: "80%",
                width: "auto",
                aspectRatio: "1/1",
              }}
            />
          )}
          <div dir="auto" className="magicform-header-company-info">
            <div
              style={{
                color: "white",
                fontSize: config.titleFontSize,
                fontWeight: 600,
                verticalAlign: "bottom",
                fontFamily: "Arial, Helvetica, sans-serif",
                lineHeight: "1.25rem",
                display: "flex",
                alignItems: "center",
              }}
            >
              {titleText}
              {adminConnected && (
                <span className="magicform-header-online-indicator" />
              )}
            </div>
            <div
              style={{
                color: "white",
                fontSize: config.subtitleFontSize,
                fontWeight: 400,
                verticalAlign: "top",
                fontFamily: "Arial, Helvetica, sans-serif",
                lineHeight: "1.25rem",
              }}
            >
              {subTitleText}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {config.showDownloadTranscript && (
            <button
              onClick={() => downloadTranscript()}
              className="magicform-header-button"
              title={downloadText}
            >
              <img
                src={mapIconUrlToGCP(config.downloadIconUrl)}
                alt="reset"
                style={{
                  width: "15px",
                  height: "15px",
                  filter:
                    calcContrastColor(colors.main) === "white"
                      ? "invert(100%)"
                      : "",
                }}
              />
            </button>
          )}
          {!config.removeRestart && (
            <button
              onClick={handleResetClick}
              className="magicform-header-button"
              title={resetText}
            >
              <img
                src={mapIconUrlToGCP(config.resetIconUrl)}
                alt="reset"
                style={{
                  width: "15px",
                  height: "15px",
                  filter:
                    calcContrastColor(colors.main) === "white"
                      ? "invert(100%)"
                      : "",
                }}
              />
            </button>
          )}
          {!config.removeClose && !(config.widgetType === "inline") && (
            <button
              className="magicform-header-button"
              onClick={toggleChatOpen}
              title={closeText}
            >
              <img
                src={mapIconUrlToGCP(config.crossIconUrl)}
                alt="exit"
                style={{
                  width: "15px",
                  height: "15px",
                  filter:
                    calcContrastColor(colors.main) === "white"
                      ? "invert(100%)"
                      : "",
                }}
              />
            </button>
          )}
        </div>
      </div>
      {headerDisclaimerText && (
        <div
          dir="auto"
          style={{
            zIndex: "1",
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 3px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
            backgroundColor: "white",
            padding: "0.5rem",
            paddingLeft: "0.75rem",
            paddingRight: "0.75rem",
            color: "gray",
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
            fontFamily: "sans-serif",
            fontSize: config.headerDiscFontSize,
            fontWeight: config.headerDiscFontWeight,
            lineHeight: "1em",
          }}
        >
          <aside>{headerDisclaimerText}</aside>
        </div>
      )}
    </>
  );
}
